import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { accordeonMe } from "src/app/animations";
import { Environment } from "src/app/classes/environment";
import { CustomerService } from "src/app/services/customer.service";


@Component( {
	selector: "legal-documents-management",
	templateUrl: "./legal-documents-management.component.html",
	styleUrls: [ './management-interface.css', 'accordeon-ui.scss' ],
	animations: [ accordeonMe ],
})
export class LegalDocumentManagementComponent implements OnInit {


	bLoading = true;
	bErrorLoading = false;

	originalContactHtml = "";
	originalTermsOfUseHtml = "";
	originalTermsOfUseChatHtml = "";
	originalPrivacyPolicyHtml = "";
	originalPrivacyPolicyChatHtml = "";
	originalImprintHtml = "";


	constructor(
		@Inject( "environment" ) public environment: Environment,
		private customerService: CustomerService,
	) {}


	ngOnInit(): void {

		this.customerService.loadLegalInformation().subscribe( result => {
			this.bLoading = false;

			this.bErrorLoading = !result;
			if( !result ) return;

			this.originalContactHtml = result.contact;
			this.originalTermsOfUseHtml = result.termsOfUse;
			this.originalTermsOfUseChatHtml = result.termsOfUseChat;
			this.originalPrivacyPolicyHtml = result.privacyPolicy;
			this.originalPrivacyPolicyChatHtml = result.privacyPolicyChat;
			this.originalImprintHtml = result.imprint;

		});

	}

}
